module.exports = __webpack_public_path__ + "img/icon-light.e925abf4.svg";